export default __webpack_public_path__ + "static/media/2.03e5f151.svg";